import React, { ReactNode, useState } from "react";

interface CollapsibleProps {
  title?: string;
  collapseTitle?: string;
  children: ReactNode;
  open?: boolean;
  onToggle?: (open: boolean) => void;
  defaultOpen?: boolean;
  id?: string;
}

export const Collapsible: React.FC<CollapsibleProps> = ({
  title = "Mostrar detalhes",
  collapseTitle = "Esconder detalhes",
  children,
  open,
  onToggle,
  defaultOpen = false,
  id = "collapsible-section",
}) => {
  const [internalOpen, setInternalOpen] = useState(defaultOpen);

  const isOpen = open !== undefined ? open : internalOpen;

  const toggle = (e?: React.MouseEvent<HTMLButtonElement>) => {
    e?.preventDefault();

    const newState = !isOpen;

    if (open === undefined) {
      setInternalOpen(newState);
    }

    onToggle?.(newState);
  };

  return (
    <div>
      <button
        type="button"
        className="btn btn-link p-0"
        aria-expanded={isOpen}
        aria-controls={id}
        onClick={toggle}
      >
        {isOpen ? collapseTitle : title}
      </button>

      <div
        id={id}
        className={`collapse ${isOpen ? "show" : ""} mt-3`}
        role="region"
        aria-hidden={!isOpen}
      >
        <div className="card card-body">{children}</div>
      </div>
    </div>
  );
};
